<template lang='pug'>
v-dialog(scrollable max-width='460px' v-model='value' persistent lazy)
  v-card
    v-card-title(class='title') Время для записи
    v-card-text
      v-form(ref='form' :disabled='true')
        v-container(grid-list-lg fluid class='pa-0')
          v-layout(row wrap)
            v-flex(v-if='!!event.busy' xs12)
              v-alert(type='info' :value='true')
                span(class='subheading')
                  | Редактирование невозможно, на осмотр записаны клиенты: {{eventModel.busy}} чел.
            v-flex(xs6)
              s-date-picker(
                :disabled='!!event.busy'
                v-model='eventModel.startDate'
                label='Дата начала'
                name='startDate'
              )
            v-flex(xs6)
              v-menu(
                :disabled='!!event.busy'
                :close-on-content-click='false'
                :return-value.sync='menus.startTime'
                v-model='menus.startTime'
                ref='startTimeMenu'
                full-width
                min-width='290px'
                lazy
              )
                v-text-field(
                  :disabled='!!event.busy'
                  :rules='validateStartTime()'
                  slot='activator'
                  v-model='eventModel.startTime'
                  label='Время начала'
                  prepend-icon='access_time'
                  readonly
                )
                v-time-picker(
                  v-if='menus.startTime'
                  @change='$refs.startTimeMenu.save(menus.startTime)'
                  v-model='eventModel.startTime'
                  format='24hr'
                  full-width
                )
            v-flex(xs6)
              s-date-picker(
                v-model='eventModel.endDate'
                label='Дата завершения'
                name='endDate'
                disabled
              )
            v-flex(xs6)
              v-menu(
                :disabled='!!event.busy'
                :close-on-content-click='false'
                :return-value.sync='menus.endTime'
                v-model='menus.endTime'
                ref='endTimeMenu'
                full-width
                min-width='290px'
                lazy
              )
                v-text-field(
                  :disabled='!!event.busy'
                  :rules='validateEndTime()'
                  slot='activator'
                  v-model='eventModel.endTime'
                  label='Время завершения'
                  prepend-icon='access_time'
                  readonly
                )
                v-time-picker(
                  v-if='menus.endTime'
                  @change='$refs.endTimeMenu.save(menus.endTime)'
                  v-model='eventModel.endTime'
                  format='24hr'
                  full-width
                )
            v-flex(xs12)
              s-schedule-complex-picker(
                :rules='[ v => !!v || "Выберите комплекс"]'
                v-model='eventModel.complex_id'
                label='Выбран комплекс'
                disabled
              )
            v-flex(v-if='eventModel.complex_id' xs12)
              s-schedule-object-picker(
                :disabled='!!event.busy'
                :rules='[ v => !!v.length || "Выберите объект"]'
                :filter='x => x.complex_id == eventModel.complex_id'
                v-model='eventModel.objects'
                label='Выберите объект'
                multiple
              )
            v-flex(xs12)
              v-select(
                :disabled='!(event.busy || (eventModel.objects && eventModel.objects.length))'
                :items='managersCount'
                :rules='[ v => !!v || "Выберите кол-во менеджеров"]'
                v-model='eventModel.allow'
                label='Количество менеджеров'
              )
    v-card-actions
      v-spacer
      v-btn(@click='$emit("input", false)' flat) Отмена
      v-btn(@click='emitChange' :loading='isLoading' flat color='primary') Ok
</template>

<script>
import { range } from 'lodash'
import { createStartEndDate } from '@/utils'

const dateFormat = 'YYYY-MM-DD'
const timeFormat = 'HH:mm'

const eventModel = {
  startDate: null,
  startTime: null,
  endDate: null,
  endTime: null,
  objects: [],
  complex_id: 0,
  allow: 0,
  busy: 0
}

export default {
  props: ['value', 'event', 'isLoading', 'duration'],

  data: () => ({
    eventModel: { ...eventModel },
    managersCount: range(1,6 ),
    menus: {
      startTime: false,
      endTime: false
    }
  }),

  methods: {
    emitChange() {
      if (this.$refs.form.validate()) {
        let { start, end } = createStartEndDate(this.eventModel)

        this.$emit('change', { ...this.eventModel, start, end })
      }
    },

    validateStartTime() {
      return [
        this.eventModel.startTime < this.eventModel.endTime ||
          'Время начала больше времени завершения'
      ]
    },

    validateEndTime() {
      return [
        this.eventModel.endTime > this.eventModel.startTime ||
          'Время завершения меньше времени начала'
      ]
    }
  },

  watch: {
    event(value) {
      if (Object.keys(value).length) {
        this.eventModel = {
          ...value,
          // Время начала
          startDate: value.start.format(dateFormat),
          startTime: value.start.format(timeFormat),
          // Время завершения
          endDate: value.end.format(dateFormat),
          endTime: value.end.format(timeFormat)
        }
        this.managersCount = range(!this.eventModel.busy ? 1 : this.eventModel.busy ,6)
      } else {
        this.eventModel = { ...eventModel }
        this.managersCount = range(1,6)
      }
    },

    'eventModel.startDate'(date) {
      this.eventModel.endDate = date
    },

    /**
     * Будем следить за состоянием видимости модального окна
     * и сбрасывать модель и валидацию, если окно закрыто
     * @param {boolean} visible
     */
    value(visible) {
      if (visible) return

      this.$refs.form.reset()
      this.eventModel = { ...eventModel }
    }
  }
}
</script>
